// Classes.
import {BooleanLocatorComponent} from './boolean.locator-component';


export class LiveLocatorComponent extends BooleanLocatorComponent {

  public constructor(_value: boolean = false) {
    super(_value);
  };

  public toString(): string {
    let str: string;

    if(this._value === null) {
      str = 'bothLive';
    }
    else if (this._value === true)     {
      str = 'Live';
    }
    else {
      str = 'NoLive';
    }

    return str;
  }

  setOnlyNoLive() {
    this._value = false;
  }

  setOnlyLive() {
    this._value = true;
  }

  setBothLiveAndNoLive() {
    this._value = null;
  }
}

